import {TicketAlreadyLinkedError} from 'src/data/api/responses/ErrorDetail';

export default function isTicketAlreadyLinkedError(
    errorPayload: Record<string, unknown>
): errorPayload is TicketAlreadyLinkedError {
    return errorPayload['code'] === 'TICKET_ALREADY_LINKED_ERROR';
}
